var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "highcharts-light user-details-usage-history-chart chart-container",
    },
    [
      _c("highcharts", {
        ref: "chartComponent",
        attrs: { options: _vm.chartOptions },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }